module.exports = __webpack_public_path__ + "media/QuatationsEmpty.0513fdb6.svg";